














































































































































































































































































































































































































































































































































// vue
import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import { strFuzzyMatch } from '@/class/common/util';
import ModalLicenceApplication from '@/components/util/ModalLicenceApplication.vue';
import ModalCancelOfContract from '@/components/util/ModalCancelOfContract.vue';
import ModalInputBase from '@/components/util/ModalInputBase.vue';
import SideMenu from '@/components/util/SideMenu.vue';
import CheckBoxList from '@/components/util/CheckBoxList.vue';

import API from '@/api/common';
import util from '@/components/util';
import { IAPP } from '@/class/models/views/app';
import * as models from '@/class/models/views/account';
import * as vi from '@/components/util/VariableInput.vue';
import account from '@/parts/account';
import { ISelectOption } from '@/class/models/typed/wild';
import SelectBoxV3, {IOption} from '@/components/util/SelectBoxV3.vue';
import ModalLicenseOption from '@/components/util/ModalLicenseOption.vue';



export default Vue.extend({
  name: 'License',
  components: {
    ...util,
    ModalLicenceApplication,
    ModalLicenseOption,
    ModalCancelOfContract,
    ModalInputBase,
    SideMenu,
    SelectBoxV3,
    CheckBoxList,
     ...account,
  },
  props: {
    appData: Object as PropOptions<IAPP>,
  },
  data() {
    return {
      onload: false,
      mode: '',
      licenseModalShowFlag: false,
      licenseOptionModalShowFlag: false,
      cancelConstract: false,
      cancelOption: false,
      isCreditInput: false,
      isConfirmCredit: false,
      // selectPayment: NOC.PAYMENT.NOSELECT,
      selectPayment: NOC.PAYMENT.BANK,
      data: '',
      licenseEditFlag: false, // ライセンス申し込み画面フラグ
      cancelEditFlag: false, // 退会申し込み画面フラグ
      editFlag: false, // お支払い情報編集フラグ
      entryFlag: false,
      paidFlag: false,
      availableFlag: false,
      dontRegistFlag: false,
      optionEditFlag: false, // オプション編集フラグ
      accountData: {} as models.IAccount,
      formData: {} as models.IAccount,
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      // price: '0',
      // thisMonth: 0,
      addressChangeModal: false,
      callbackForAddress: (_: models.IAccount) => {},
      invoiceFormData: {} as {year: number, month: number},
      invoiceItems: [
        {key: 'year', name: '', type: vi.INPUT_TYPE.SELECT, placeholder: '', required: true, error: '', options: [{text: '　', value: 0}]},
        {key: 'month', name: '', type: vi.INPUT_TYPE.SELECT, placeholder: '', required: true, error: '', options: [{text: '　', value: 0}]},
      ] as vi.IVariableInput[],
      invoiceList: {} as {[key: string]: string[]},
      selectedYear: 0,
      newSelectedYear: 0,
      editDeviceList: [] as models.VExtensionDevice[],
      tableItems: [] as any[],
      tableFields: [
        { key: 'checked', label: '' },
        { key: 'deviceName', sortable: true, label: 'デバイス名' },
        { key: 'linkedUsersLabel', sortable: true, label: '関連付けユーザー' },
      ] as any[],
      searchText: '',
      inputedSearchText: '',
    };
  },
  computed: {
    IN_USE(): boolean {
      return (this.appData.contractStatus === NOC.CONTRACT.REGIST
        || this.appData.contractStatus === NOC.CONTRACT.DELAY);
    },
    DELAY(): boolean {
      return this.appData.contractStatus === NOC.CONTRACT.DELAY;
    },
    USE_STOP(): boolean {
      return (this.appData.contractStatus === NOC.CONTRACT.CONFIRM
        || this.appData.contractStatus === NOC.CONTRACT.STOP);
    },
    USE_QUIT(): boolean {
      return (this.appData.contractStatus === NOC.CONTRACT.CONFIRM
        || this.appData.contractStatus === NOC.CONTRACT.STOP
        || this.appData.contractStatus === NOC.CONTRACT.QUIT);
    },
    USE_OPTION(): boolean {
      return (
        (this.appData.contractStatus === NOC.CONTRACT.REGIST
        || this.appData.contractStatus === NOC.CONTRACT.DELAY
        || this.appData.contractStatus === NOC.CONTRACT.CONFIRM)
        && Number(this.accountData.quit) === 0
      );
    },
    OPTION_QUIT(): boolean {

      const next = this.accountData.extensionData.nextExtensionData;
      if (!next) {
        return false;
      }
      return Number(this.accountData.extensionData.extensionYear) !== 0 && Number(next.extensionYear) === 0;
    },
    // MODE_NOT_APPLICATION(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.NOT_APPLICATION);
    // },
    // MODE_APPLICATION(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.APPLICATION);
    // },
    // MODE_CONFIRMATION(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.CONFIRMATION_BANKS);
    // },
    // MODE_CONTRACTED_BANKS(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.CONTRACTED_BANKS);
    // },
    // MODE_CONTRACTED_CREDIT(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.CONTRACTED_CREDIT);
    // },
    // MODE_PAYMENT_EDIT(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.PAYMENT_EDIT);
    // },
    // MODE_CANCEL_CONSTRACTED(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.CANCEL_CONSTRACTED);
    // },
    NOSELECT(): number {
      return NOC.PAYMENT.NOSELECT;
    },
    CREDIT(): number {
      return NOC.PAYMENT.CREDIT;
    },
    BANK(): number {
      return NOC.PAYMENT.BANK;
    },
    CAMPAIGN(): boolean {
      return this.accountData.isExtension;
    },
    CAMPAIGN_DAYS(): number {
      return this.accountData.isExtensionDays;
    },
    CAMPAIGN_DAYS_END(): string {
      return this.accountData.isExtensionEnd;
    },
    INVOICE_PERIODS_LENGTH(): number {
      if (!this.accountData.invoicePeriods) {
        return 0;
      }
      return this.accountData.invoicePeriods.length;
    },
    INVOICE_YEAR(): number {
      return this.invoiceFormData.year;
    },
    IS_NOT_SELECTED_PAYMENT(): boolean {
      return this.selectPayment === 0;
    },
    YEAR_OPTIONS(): ISelectOption[] {
      // 選択肢初期化
      const options: ISelectOption[] = [{ value: 0, text: '0' }];
      // アカウント登録日を取得
      const createdAtDate = new Date(this.accountData.createdAt);
      // 何ヶ月利用しているか計算
      const currentMonths = this.currentYear * 12 + this.currentMonth - 1;
      const firstMonths = createdAtDate.getFullYear() * 12 + createdAtDate.getMonth();
      const diff = currentMonths - firstMonths;
      // 2年前より前の延長可能な年数を計算
      const years = Math.ceil(diff / 12) - 2; // 端数の月は切り上げ
      // 年数の選択肢を追加
      for (let i = 1; i <= years; i++) {
        options.push({ value: i, text: `${i}` });
      }
      return options;
    },
    // viewableYearEdit(): number { // 閲覧可能データ
    //   return this.currentYear - 2 - Number(this.newSelectedYear);
    // },
    // viewableYear(): number {
    //   return this.currentYear - 2 - Number(this.selectedYear);
    // },
    // previousMonth(): number { // 閲覧可能データ
    //   return this.currentMonth === 1 ? 12 : this.currentMonth - 1;
    // },
    // previousMonthLastDay(): number { // 閲覧可能データ
    //   // return new Date(this.viewableYear + this.selectedYear, this.previousMonth, 0).getDate();
    //   return new Date(this.currentYear, this.currentMonth - 1, 0).getDate();
    // },
    VIEWABLE_PERIOD(): string { // 閲覧可能データ
      const fromYear = this.currentYear - 2 - Number(this.newSelectedYear);
      // const toMonth = this.currentMonth === 1 ? 12 : this.currentMonth - 1;
      // const toDay = new Date(this.currentYear, this.currentMonth - 1, 0).getDate();
      // return `${fromYear}年${this.currentMonth}月1日～${this.currentYear}年${toMonth}月${toDay}日`;
      return `${fromYear}年${this.currentMonth}月1日～本日`;
    },
    checkSelectedYearIsSame(): boolean {
      // 延長年数が変更なしでデバイスリストがチェックなしの場合、true
      const checkCount = this.editDeviceList.filter((e) => e.extensionFlag).length;
      return Number(this.selectedYear) === Number(this.newSelectedYear) && !this.editDeviceList.some((v) => v.extensionFlag) || checkCount === 0 || Number(this.newSelectedYear) === 0;
    },
    // option_charge(): number {
    //   return this.selectedYear * this.accountData.extensionData.extensionClientCount * 110;
    // },
    // clientCount(): number {
    //   // return this.editDeviceList.filter((v) => v.extensionFlag).length;
    // },
  },
  watch: {
    // async mode() {
    //   if (this.licenseEditFlag || this.editFlag) {
    //     await this.createdPayjpCheckout();
    //   } else {
    //     this.removePayJpFrame();
    //   }
    // },
    async licenseEditFlag(value) {
      if (value) {
        await this.createdPayjpCheckout();
      } else {
        this.removePayJpFrame();
      }
    },
    async editFlag(value) {
      if (value) {
        await this.createdPayjpCheckout();
      } else {
        this.removePayJpFrame();
      }
    },
    selectPayment(value) {
      if (value === this.CREDIT) {
        // this.createdPayjpCheckout();
        if (this.isCreditInput) {
          this.isConfirmCredit = true;
        } else {
          this.isConfirmCredit = false;
        }
      } else {
        this.isConfirmCredit = true;
      }
    },
    INVOICE_YEAR: {
      handler(year: number, oldYear: number) {
        let inheritMonth = false;
        const monthItem = this.invoiceItems.find((v) => v.key === 'month');
        if (monthItem) {
          const months = [] as ISelectOption[];
          for (const value of this.invoiceList[year.toString()]) {
            months.push({text: `${Number(value)}月`, value: Number(value)});
            if (this.invoiceFormData.month === Number(value)) {
              inheritMonth = true;
            }
          }
          monthItem.options = months;
          const latestMonths = Math.max(...months.map((v) => v.value));
          if (oldYear === undefined) {
            // 最新の月をデフォルト（初回だけ）
            this.$set(this.invoiceFormData, 'month', latestMonths);
          } else {
            if (!inheritMonth) {
              this.$set(this.invoiceFormData, 'month', latestMonths);
            }
          }
        }
      },
    },
  },
  // 画面表示時処理
  async mounted() {
    // データ取得
    const api = new API();
    const res = await api.get<models.IAccount>('account');

    if (res.result) {
      this.accountData = res.data;
      this.formData = JSON.parse(JSON.stringify(this.accountData));
      this.setStatus(this.formData);
      if (this.accountData.invoicePeriods.length) {
        // 利用年月の年と月の選択肢を整理
        for (const invoicePeriod of this.accountData.invoicePeriods) {
          const year = invoicePeriod.toString().slice(0, 4);
          const myMonth = invoicePeriod.toString().slice(4);
          if (this.invoiceList[year]) {
            this.invoiceList[year].push(myMonth);
          } else {
            this.invoiceList[year] = [myMonth];
          }
        }
        // 利用年月の年の選択肢をセットし、最新の年をデフォルト
        const yearItem = this.invoiceItems.find((v) => v.key === 'year');
        if (yearItem) {
          const years = [] as ISelectOption[];
          for (const key of Object.keys(this.invoiceList)) {
            years.push({text: `${key}年`, value: Number(key)});
          }
          yearItem.options = years;
          const latestYear = Math.max(...years.map((v) => v.value));
          this.$set(this.invoiceFormData, 'year', latestYear);
        }
      }
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }
    this.$emit('pushPath', this.$route.path);

    // 初めて登録するユーザーの場合
    // if (this.formData.payment === 0 && this.formData.quit === 0) {
    //   this.mode = NOC.SETTING.MODE.NOT_APPLICATION;
    // } else {
      // 登録中のユーザー
      // if (this.formData.payment === 2 && this.formData.quit === 0) {
      //   this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      // } else if (this.formData.payment === 1 && this.formData.quit === 0) {
      //   this.mode = NOC.SETTING.MODE.CONTRACTED_CREDIT;
      // } else {
      //   // 解約済みのユーザー
      //   if (this.formData.payment === 2 && this.formData.quit === 1) {
      //     this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      //   } else if (this.formData.payment === 1 && this.formData.quit === 1) {
      //     this.mode = NOC.SETTING.MODE.CONTRACTED_CREDIT;
      //   }
      // }
    // }

    if (this.selectPayment === 2) {
      this.isConfirmCredit = true;
    }

    (window as any).tokenCreated = this.tokenCreated;
    // console.log((window as any).tokenCreated);

    // 読み込み完了
    this.onload = true;
  },
  beforeDestroy() {
    this.removePayJpFrame();
  },
  methods: {
    // オプション更新モーダルの決定後
    async changeOption() {
      const requestData = {
        currentExtensionYear: this.newSelectedYear,
        deviceList: this.editDeviceList,
      } as models.IAccount;

      const api = new API();
      const res = await api.put<models.IAccount, models.VExtensionData>('account/extension', requestData);
      if (res.result) {
        this.accountData.extensionData = res.data;
        this.selectedYear = this.newSelectedYear;
        this.newSelectedYear = 0;
        this.accountData.currentExtensionYear = this.selectedYear;
        this.optionEditFlag = false;
      } else {
        let message = '更新できませんでした。';
        const errorMessage = api.isError();
        if (errorMessage) {
          message += '\n' + errorMessage.message;
        }
        this.$emit('info', message);
      }
      this.licenseOptionModalShowFlag = false;
    },
    updateSelectedYear(newValue: string) {
      this.newSelectedYear = Number(newValue);
    },
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    removePayJpFrame() {
      const payjpCheckoutIframeEl: any = document.getElementById(
        'payjp-checkout-iframe',
      );
      if (payjpCheckoutIframeEl) {
        payjpCheckoutIframeEl.parentElement.remove();
      }
      (window as any).tokenCreated = null;
      (window as any).PayjpCheckout = null;
    },
    // 申し込みボタン押下時処理
    onClickApplication() {
      // this.mode = NOC.SETTING.MODE.APPLICATION;
      // this.selectPayment = 2;
      this.licenseEditFlag = true;
      this.selectPayment = this.accountData.payment;
    },
    // 戻るボタン、キャンセルボタン　押下時処理
    selectBack() {
      if (this.licenseEditFlag) {
        this.licenseModalShowFlag = false;
        this.licenseEditFlag = false;
      } else if (this.cancelEditFlag) {
        this.cancelEditFlag = false;
      } else if (this.editFlag) {
        this.editFlag = false;
      } else if (this.optionEditFlag) {
        this.optionEditFlag = false;
      }
      // if (
      //   (this.addModalShowFlag &&
      //     this.checkMode(NOC.SETTING.MODE.APPLICATION)) ||
      //   this.checkMode(NOC.SETTING.MODE.CONTRACTED_BANKS) ||
      //   this.checkMode(NOC.SETTING.MODE.CONTRACTED_CREDIT)
      // ) {
      //   this.addModalShowFlag = false;
      // } else if (this.cancelConstract) {
      //   this.cancelConstract = false;
      // } else if (this.checkMode(NOC.SETTING.MODE.APPLICATION)) {
      //   this.mode = NOC.SETTING.MODE.NOT_APPLICATION;
      //   // (window as any).tokenCreated = null;
      //   // (window as any).PayjpCheckout = null;

      // } else if (this.MODE_PAYMENT_EDIT) {
      //   this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      // } else if (this.checkMode(NOC.SETTING.MODE.CANCEL_CONSTRACTED)) {
      //   this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      // } else {
      //   this.mode = NOC.SETTING.MODE.NOT_APPLICATION;
      // }
      this.removePayJpFrame();
    },
    // 申し込みボタン押下時処理
    onClickConfirmation(eventObj: {payment: number, token: string}) {
      this.formData.quit = 0;
      this.changePayment(eventObj);
      // if (!this.addressChangeModal) {
      //   // if (this.selectPayment === this.CREDIT) {
      //   //   this.mode = NOC.SETTING.MODE.CONTRACTED_CREDIT;
      //   // } else {
      //   //   this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      //   // }
      //   this.licenseEditFlag = false;
      // }
      // this.licenseModalShowFlag = false;
    },
    // 編集ボタン押下時処理(仮)
    onClickPaymentEdit() {
      // this.mode = NOC.SETTING.MODE.PAYMENT_EDIT;
      this.editFlag = true;
      this.selectPayment = this.accountData.payment;
    },
    // 支払い方法変更　更新ボタン押下時処理
    changePaymentMethod() {
      let token = '';
      this.editFlag = false;
      if (this.selectPayment === this.CREDIT) {
        // this.mode = NOC.SETTING.MODE.CONTRACTED_CREDIT;
        const payjpToken: any = document.getElementsByName('payjp-token')[0];
        token = payjpToken.value;
      // } else {
        // this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      }
      this.changePayment({ payment: this.selectPayment, token });
    },
    // 申し込みボタン押下時処理 申し込み確認モーダル表示
    onAddModal() {
      this.licenseEditFlag = true;
      // if (this.formData.quit === 0 && this.formData.payment === this.BANK) {
      //   if (this.selectPayment === this.CREDIT) {
      //     this.licenseModalShowFlag = true;
      //   }
      // } else {
      //   this.licenseModalShowFlag = true;
      // }
    },
    // 解約ボタン押下時処理
    onClickCancelConstracted() {
      // this.mode = NOC.SETTING.MODE.CANCEL_CONSTRACTED;
      this.cancelEditFlag = true;
    },
    // 解約確認モーダル表示処理
    onClickCancelConstract() {
      this.cancelConstract = true;
      this.licenseModalShowFlag = false;
    },
    // オプション編集ボタン押下時処理
    onClickOptionEdit() {
      this.optionEditFlag = true;
      this.selectedYear = this.accountData.currentExtensionYear;
      this.setDeviceList(this.accountData);
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    // オプション確認モーダル表示処理
    onClickOptionConfirm() {
      this.licenseOptionModalShowFlag = true;
    },
    // オプション解約モーダル表示処理
    onClickOptionCancel() {
      this.cancelOption = true;
    },
    async createdPayjpCheckout() {
      (window as any).tokenCreated = this.tokenCreated;
      await this.$nextTick(); // DOMの更新を待つ
      const checkoutEl = document.createElement('script');
      checkoutEl.setAttribute('data-key', process.env.VUE_APP_PJ);
      checkoutEl.setAttribute('id', 'payjp-script');
      checkoutEl.setAttribute('src', 'https://checkout.pay.jp/');
      checkoutEl.setAttribute('class', 'payjp-button');
      checkoutEl.setAttribute('data-lang', 'ja');
      checkoutEl.setAttribute('data-partial', 'true');
      checkoutEl.setAttribute('data-submit-text', 'カード情報を入力する');
      checkoutEl.setAttribute('data-text', 'カード情報を入力する');
      checkoutEl.setAttribute('data-name-placeholder', 'ICHIROU TANAKA');
      checkoutEl.setAttribute('data-on-created', 'tokenCreated');
      const myform = this.$refs.creditForm as Element;
      myform.appendChild(checkoutEl);
    },
    // onClickSelectPayment() {
    //   if (this.selectPayment !== this.NOSELECT) {
    //   // if (this.formData.payment !== this.NOSELECT) {
    //     this.$data.modalTitle = 'ご登録の確認';
    //     this.$data.isConfirmScreen = true;
    //     this.createdPayjpCheckout();
    //   }
    // },
    tokenCreated() {
      this.$data.isConfirmCredit = true;
      this.$data.isCreditInput = true;
    },
    async changePayment(eventObj: {payment: number, token: string}, data?: models.IAccount): Promise<boolean> {
      // this.formData.payment = eventObj.payment;
      // this.formData.token = eventObj.token;
      // this.formData.quit = 0;

      if (!this.accountData.postalCode.length && !data) {
        // 郵便番号が未入力で住所モーダル未表示の場合は住所入力モーダル表示
        this.addressChangeModal = true;
        // 住所入力後に本メソッドを再実行する
        this.callbackForAddress = (dataAcc: models.IAccount) => this.changePayment(eventObj, dataAcc);
        return false;
      } else {
        if (data) {
          // 住所モーダルで入力済ならformDataに反映
          this.formData = data;
        }
        // 支払方法をformDataに反映
        this.formData.payment = eventObj.payment;
        this.formData.token = eventObj.token;
        // this.formData.quit = 0; // 第３次デザインでは退会済みでも支払い情報変更可能であるため退会状態を維持
      }
      // api start
      const api = new API();
      const res = await api.put<models.IAccount, any>('account/regist', this.formData);
      const errorMessage = api.isError();
      // result
      if (res.result) {
        // 通信して成功時に再設定 (新しく受信したプロパティだけ上書き)
        for (const prop of Object.keys(res.data)) {
          (this.accountData as any)[prop] = res.data[prop];
        }
        // this.accountData = res.data;
        this.$emit('changeContract');
        this.setStatus(this.accountData);
        this.licenseModalShowFlag = false;
        this.licenseEditFlag = false;
        this.editFlag = false;
      } else {
        let message = '更新できませんでした。';
        if (errorMessage) {
          message += '\n' + errorMessage.message;
        }
        this.$emit('info', message);
        return false;
      }
      return true;
    },
    // ライセンス解約
    async onClickQuit(): Promise<boolean> {
      this.cancelConstract = false;
      // this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      this.formData.quit = 1;

      // api start
      const api = new API();
      const res = await api.put<models.IAccount, any>('account/regist', this.formData);
      // result
      if (res.result) {
        // 通信して成功時に再設定 (新しく受信したプロパティだけ上書き)
        for (const prop of Object.keys(res.data)) {
          (this.accountData as any)[prop] = res.data[prop];
        }
        // this.accountData = res.data;
        this.cancelEditFlag = false;
        this.$emit('changeContract');
        this.setStatus(this.accountData);
      } else {
        this.$emit('info', '更新できませんでした。');
        return false;
      }
      return true;
    },
    // オプション解約
    async onClickQuitOption() {
      const requestData = {
        currentExtensionYear: 0,
        deviceList: this.editDeviceList,
      } as models.IAccount;

      const api = new API();
      const res = await api.put<models.IAccount, models.VExtensionData>('account/extension', requestData);
      if (res.result) {
        this.accountData.extensionData = res.data;
        this.selectedYear = this.newSelectedYear;
        this.newSelectedYear = 0;
        this.accountData.currentExtensionYear = this.selectedYear;
        this.optionEditFlag = false;
      } else {
        let message = '更新できませんでした。';
        const errorMessage = api.isError();
        if (errorMessage) {
          message += '\n' + errorMessage.message;
        }
        this.$emit('info', message);
      }
      this.cancelOption = false;
    },
    setStatus(data: models.IAccount) {
      let newEntryFlag = false;
      let newPaidFlag = true;
      let newAvailableFlag = data.quit === 0;
      switch (this.appData.contractStatus) {
        case NOC.CONTRACT.TRIAL:
          newEntryFlag = true;
          newPaidFlag = false;
          break;
        case NOC.CONTRACT.CONFIRM:
        case NOC.CONTRACT.STOP:
          this.dontRegistFlag = true;
          newAvailableFlag = false;
          break;
      }
      this.availableFlag = newAvailableFlag;
      this.entryFlag = newEntryFlag;
      this.paidFlag = newPaidFlag;
    },
    // 住所変更モーダル
    // 郵便番号欄が無かった頃に登録したアカウントが申込や支払方法変更などを行う際に
    // 必須項目エラーになってしまうため、住所を追加入力できるようにする
    async changeAddress(data: models.IAccount) {
      // this.formData = data;
      this.callbackForAddress(data);
      // モーダルクローズ＆リセット
      this.addressChangeModal = false;
      this.callbackForAddress = () => {};

      // if (this.selectPayment === 2) {
      //   this.mode = NOC.SETTING.MODE.CONTRACTED_BANKS;
      // } else if (this.selectPayment === 1) {
      //   this.mode = NOC.SETTING.MODE.CONTRACTED_CREDIT;
      // }
      this.licenseEditFlag = false;
    },
    async onClickShowInvoice() {
      // validation エラーの場合
      const errorNum = vi.checkValues(this.invoiceFormData, this.invoiceItems);
      if (errorNum) {
        return;
      }

      const period = `${this.invoiceFormData.year}${('00' + this.invoiceFormData.month).slice(-2)}`;

      const api = new API();
      const res = await api.get<models.VInvoice>('account/invoice', { period });
      if (res.result) {
        localStorage.setItem('/Invoice', JSON.stringify(res.data));
        window.open('/Invoice', 'invoiceWindow', 'popup');
      } else {
        this.$emit('info', '通信できませんでした。');
      }
    },
    // デバイスリスト設定
    setDeviceList(accountData: models.IAccount) {
      this.editDeviceList = JSON.parse(JSON.stringify(accountData.extensionData.deviceList));
      this.tableItems = JSON.parse(JSON.stringify(accountData.extensionData.deviceList));
      // テーブル表示設定
      for (const item of this.tableItems) {
        // チェックボックス
        item.checked = item.extensionFlag;
        // 関連付けユーザーのラベル
        item.linkedUsersLabel =
          item.linkedUsers
          .map((elem: models.VExtensionUser) => `${elem.name}(${elem.pcAccountName})`)
          .join('、');
      }
    },
    // 絞り込むボタン押下時処理
    onClickFilter() {
      this.searchText = this.inputedSearchText;
    },
    filteringDevice(row: models.VExtensionDevice, filter: string) {
      // デバイス名、ユーザー名、PCアカウント名のいずれかにヒットしたら表示
      return !filter || strFuzzyMatch(filter, row.deviceName) || row.linkedUsers.some((v) => {
        return strFuzzyMatch(filter, v.name) || strFuzzyMatch(filter, v.pcAccountName);
      });
    },
    onCheckDevice(data: models.VExtensionDevice, checked: boolean) {
      for (const device of this.editDeviceList) {
        if (device.deviceUid === data.deviceUid) {
          device.extensionFlag = checked;
          break;
        }
      }
    },
    onCheckAllDevices(checked: boolean) {
      for (const device of this.editDeviceList) {
        device.extensionFlag = checked;
      }
    },
  },
});
